import { isDOMAccessible } from '@/utils/dom'

export default () => {
  if (isDOMAccessible()) {
    window.googletag = window.googletag || {}
    window.googletag.cmd = window.googletag.cmd || []
  }
}
